  function addPageLoadedClass() {
    document.body.classList.add('page-loaded');
    document.dispatchEvent(new CustomEvent('initSlickSlider'));
    // Remove all event listeners after the first interaction
    window.removeEventListener('scroll', onFirstInteraction);
    window.removeEventListener('keydown', onFirstInteraction);
    window.removeEventListener('mousemove', onFirstInteraction);
    window.removeEventListener('touchstart', onFirstInteraction);
    window.removeEventListener('click', onFirstInteraction);
  }

  function onFirstInteraction() {
    addPageLoadedClass();
  }

  // Listen for the first interaction of any kind
  window.addEventListener('scroll', onFirstInteraction, { once: true });
  window.addEventListener('keydown', onFirstInteraction, { once: true });
  window.addEventListener('mousemove', onFirstInteraction, { once: true });
  window.addEventListener('touchstart', onFirstInteraction, { once: true });
  window.addEventListener('click', onFirstInteraction, { once: true });


Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        $("sticky-header").removeClass("color-accent-1");
        $("sticky-header").addClass("color-scheme-1");
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      $("sticky-header").removeClass("color-accent-1");
      $("sticky-header").addClass("color-scheme-1");

      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    var stickyHeaderVar = document.querySelector('sticky-header');
    if (stickyHeaderVar && typeof stickyHeaderVar.onScroll === 'function') {
      stickyHeaderVar.onScroll(); // simulate one scroll pass
    }
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      var stickyHeaderVar = document.querySelector('sticky-header');
      if (stickyHeaderVar && typeof stickyHeaderVar.onScroll === 'function') {
        stickyHeaderVar.onScroll(); // simulate one scroll pass
      }
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      $("sticky-header").removeClass("color-accent-1");
      $("sticky-header").addClass("color-scheme-1");
      this.mainDetailsToggle.classList.add('menu-opening');

    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) { 
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
    console.log('currentVariant =', this.currentVariant.id);
    metaChange(this.currentVariant.id);
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    
    if (!addButton) return;
    addButton.classList.add("prod-btn-active");
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      addButton.setAttribute('disable','true');
      if (text) addButtonText.innerHTML = text  +"<span class='price-ele'>"+ Currency.formatMoney(this.currentVariant.price , window.moneyFormat)+"</span>";
    } else {
      addButton.removeAttribute('disabled');
      addButton.setAttribute('disable','false');
      if (document.body.classList.contains('preorder-product')) {
          addButtonText.innerHTML = 'PREORDER NOW' +"<span class='price-ele'>"+ Currency.formatMoney(this.currentVariant.price , window.moneyFormat)+"</span>";
      } else {
          addButtonText.innerHTML = window.variantStrings.addToCart +"<span class='price-ele'>"+ Currency.formatMoney(this.currentVariant.price , window.moneyFormat)+"</span>";
      }
      
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


$('.mobile-facets__clear-wrapper a').on( 'click', function(e){
    location.href = $(this).attr('href');
});




  
var setCookie = function (name, value) {
  var date = new Date(),
      expires = 'expires=';

  date.setDate(date.getDate() + 7);

  expires += date.toGMTString();
  document.cookie = name + '=' + value + '; ' + expires + '; path=/';
}

var getCookie = function (name) {
    var allCookies = document.cookie.split(';'),
      cookieCounter = 0,
      currentCookie = '';
    for (cookieCounter = 0; cookieCounter < allCookies.length; cookieCounter++) {
      currentCookie = allCookies[cookieCounter];
      while (currentCookie.charAt(0) === ' ') {
        currentCookie = currentCookie.substring(1, currentCookie.length);
      }
      if (currentCookie.indexOf(name + '=') === 0) {
        return currentCookie.substring(name.length + 1, currentCookie.length);
      }
    }
    return false;
  }

function removeItem(sKey, sPath, sDomain) {
    document.cookie = encodeURIComponent(sKey) + 
                  "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + 
                  (sDomain ? "; domain=" + sDomain : "") + 
                  (sPath ? "; path=" + sPath : "");
}

  
  var popupEle = '';
  var x = setInterval(function(){
      removeItem('locale_bar_dismissed');
	  
      // For Recommendation popup.
	  popupEle = $('.recommendation-modal__container');
      if(!popupEle.hasClass('changed') && popupEle.length){
		popupEle.find('.recommendation-modal__close-button').css('visibility', 'hidden');
        popupEle.find('.recommendation-modal__button--minimal').css('visibility', 'hidden');
        
        //popupEle.find('.recommendation-modal__message').text('Lorem ipsum dolor sit amet, consectetur adipiscing elit.');
        //popupEle.find('.recommendation-modal__benefits li').first().text('LOrem ipsum');
        //popupEle.find('.recommendation-modal__benefits li').last().text('Sed vehicula, magna a consequat');
        popupEle.addClass('changed');
        console.log('changed');

		popupEle.bind("DOMSubtreeModified", function() { 
          if(popupEle.length){
            popupEle.find('.recommendation-modal__close-button').css('visibility', 'hidden');
            popupEle.find('.recommendation-modal__button--minimal').css('visibility', 'hidden');
          }
		});
      }
  },1000);





$(document).ready(function() {
    var storedNumber = getCookie("data-number");
    
    if (storedNumber !== null && storedNumber !== "" && !isCookieExpired("data-number") && storedNumber) {
        // console.log("Stored Number:", storedNumber);
        $(".menu-badge").text(storedNumber);
    } else {
      if($(".menu-badge").length){
        var numbers = $(".menu-badge").data("number").split(",").map(Number);
        var randomIndex = Math.floor(Math.random() * numbers.length);
        var randomNumber = numbers[randomIndex];
        // console.log("Random Number:", randomNumber);
        setCookie("data-number", randomNumber, 1);
        $(".menu-badge").text(randomNumber);
      }
    }
});

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function isCookieExpired(name) {
    var cookieValue = getCookie(name);
    if (cookieValue === null || cookieValue === "") {
        return true;
    }
    return false;
}

$(document).ready(function() {
    var timeInSeconds = parseInt($('.cart-counter').attr('counter-time'), 10);
    var count = 1;
    var timer = setInterval(function() {
    var cartCount = parseInt($('.cart-product-count').attr('cart-count'));
    if(count != cartCount){
      count = cartCount;
      timeInSeconds = parseInt($('.cart-counter').attr('counter-time'), 10);
    }
    timeInSeconds--;
    var minutes = Math.floor(timeInSeconds / 60);
    var seconds = timeInSeconds % 60;
    $('.cart-counter').text(`${minutes}:${seconds.toString().padStart(2, '0')}`);    
    if (timeInSeconds <= 0) {
      clearInterval(timer);
      $('.cart-reserved').hide();
    }
  }, 1000);

  $("body").on("click", ".complementary-products .size-wrapper .product-available a", function(event){
    event.preventDefault();
    var variantId = $(this).parent().attr('data-id');
    $(this).closest('.card__content').find('.quick-add input[name="id"]').val(variantId);
    $(this).closest('.card__content').find('.quick-add .quick-add__submit').click();
    $(this).parent().addClass('active');
  });
  
  $("body").on("click", ".complementary-products-wrapper .modal-toggle", function(event){
    event.preventDefault();
    $('.complemetary-quick-add.active').removeClass('active');
    $(this).closest('.product-card-wrapper').find('.complemetary-quick-add').addClass('active');
  });
  $("body").on("click", ".complemetary-quick-add .modal-close", function(event){
    event.preventDefault();
    $('.complemetary-quick-add.active').removeClass('active');
  });
});


function metaChange(currentVariant){
   const selectedVariantId = currentVariant;
   var sectionId = $('.main-product-section').find('section').attr('data-section');
   var productLink = $('.product-handle-wrap').attr('product-handle');
    $.ajax({
      url: `/products/${productLink}/?variant=${selectedVariantId}&section_id=${sectionId}`,
      method: 'GET',
      success: function(data) {
        const $tempDiv = $('<div>').html(data);
        var newHtml = $tempDiv.find('#meta-sizing').html();
        if($('#meta-sizing').length){
           $('#meta-sizing').html(newHtml); 
        }
      },
      error: function(error) {
        console.error('Error fetching section:', error);
      }
    });
}



// $('body').on('click', '.size-wrapper li a', function(event) {
//     event.preventDefault();
//     var variantId = $(this).attr('href').split('=')[1];
//     var link = $(this);
//     console.log('vARIANT ID =',variantId);
//     $(this).closest('li').addClass('active');
//     var productForm = $(this).closest('.product-card-wrapper').find('product-form form');
//     productForm.find('input[name="id"]').val(variantId);
//     productForm.find('button[type="submit"]').click();    
//     setTimeout(function() {
//       link.closest('li').removeClass('active');
//       link.closest('li.grid__item').removeClass('size-active');
//     }, 1500);
// });

$('body').on('click', '.product-card-wrapper .option-wrapper li a', function (e) {
  e.preventDefault();

  console.log('---------------- OPTION CLICK ----------------');

  var li = $(this).closest('li');
  var card = li.closest('.product-card-wrapper');

  if (!card.length) {
    console.warn('No product card found');
    return;
  }

  var clickedOptionIndex = Number(li.data('option-index'));
  var clickedValue = String(li.data('option-value')).trim();

  console.log('Clicked index =', clickedOptionIndex);
  console.log('Clicked value =', clickedValue);

  // ---------------- ACTIVE STATE ----------------
  li.siblings().removeClass('active');
  li.addClass('active');

  // ---------------- GET VARIANTS ----------------
  var variantsRaw = card.find('.product-variants-data').html();

  if (!variantsRaw) {
    console.warn('Variant JSON missing in this card');
    return;
  }

  var variants = JSON.parse(variantsRaw);

  console.log('Total variants =', variants.length);

  // ---------------- BUILD SELECTED OPTIONS ----------------
  var selectedOptions = {};

  card.find('.option-wrapper li.active').each(function () {
    var idx = Number($(this).data('option-index'));
    var val = String($(this).data('option-value')).trim();
    selectedOptions[idx] = val;
  });

  console.log('Selected options =', selectedOptions);

  // ---------------- FILTER MATCHING VARIANTS ----------------
  var matchingVariants = variants.filter(function (variant) {
    return variant.options.every(function (opt, i) {
      if (!selectedOptions.hasOwnProperty(i)) return true;
      return String(opt).trim() === selectedOptions[i];
    });
  });

  console.log('Matching variants count =', matchingVariants.length);

  // ================= OPTION GROUP COUNT CHECK =================
  var optionGroupCount = card.find('.option-wrapper').length;
  console.log('Option group count =', optionGroupCount);

  // ---------------- AVAILABILITY LOGIC ONLY IF > 1 ----------------
  if (optionGroupCount > 1) {

    // RESET
    card.find('.option-wrapper li')
        .removeClass('product-available product-unavailable');

    // APPLY
    card.find('.option-wrapper li').each(function () {

      var item = $(this);
      var idx = Number(item.data('option-index'));
      var val = String(item.data('option-value')).trim();

      // DO NOT TOUCH SAME GROUP
      if (idx === clickedOptionIndex) {
        item.addClass('product-available');
        return;
      }

      var available = matchingVariants.some(function (v) {
        return String(v.options[idx]).trim() === val && v.available;
      });

      item.addClass(available ? 'product-available' : 'product-unavailable');
    });

    console.log('Availability classes updated');

  } else {
    console.log('Single option product → skip cross availability');
  }

  // ---------------- FIND EXACT VARIANT ----------------
  var exactVariant = matchingVariants.find(function (v) {

    if (!v.available) return false;

    return v.options.every(function (opt, i) {
      if (!selectedOptions.hasOwnProperty(i)) return false;
      return String(opt).trim() === selectedOptions[i];
    });
  });

  if (exactVariant) {
    console.log('Exact variant FOUND =', exactVariant.id);

    card.find('input[name="id"]').val(exactVariant.id);

    // ---------------- AUTO SUBMIT ----------------
    var totalOptionGroups = optionGroupCount;
    var selectedCount = Object.keys(selectedOptions).length;

    if (selectedCount === totalOptionGroups) {
      console.log('All options selected → Auto submit');

      var btn = card.find('button[type="submit"]');

      if (btn.length) {
        setTimeout(function () {
          btn.trigger('click');
          $(".custom-quick-add li.active").removeClass("active");
          card.find(".custom-quick-add").addClass("loader-active");
        }, 250);
      }
    }

  } else {
    console.warn('Exact variant NOT found');
  }

  console.log('---------------- END CLICK ----------------');
});

$(document).ready(function () {

  $('.product-card-wrapper').each(function () {
    var card = $(this);

    var variantsRaw = card.find('.product-variants-data').html();
    console.log("variantsRaw =",variantsRaw);
    if (!variantsRaw) return;

    var variants = JSON.parse(variantsRaw);

    // if more than 1 option → skip
    if (!variants.length || variants[0].options.length !== 1) {
      return;
    }

    console.log('Single option product detected');

    card.find('.option-wrapper li').each(function () {
      var li = $(this);
      var value = String(li.data('option-value')).trim();

      // find variant for this value
      var matched = variants.find(function (v) {
        return String(v.options[0]).trim() === value;
      });

      li.removeClass('product-available product-unavailable');

      if (matched && matched.available) {
        li.addClass('product-available');
      } else {
        li.addClass('product-unavailable');
      }
    });

  });

});


$('body').on('click', '.quick-buy-button', function(event) {
    $('li.size-active, .collage__item').removeClass('size-active'); 
    $(this).closest('li').addClass('size-active');
    $(this).closest('.collage__item').addClass('size-active');
});
$('body').on('click', '.size-modal-wrap .overlay', function(event) {
    $('li.size-active').removeClass('size-active');
    $('.collage__item.size-active').removeClass('size-active');
});


// Remove when clicking the SVG inside the popup box
$('body').on('click', '.xmas-popup-box span', function (e) {
    e.stopPropagation();
    $(this).closest(".xmas-popup-overlay").remove();
});

// Remove when clicking outside the popup overlay
$('body').on('click', function (e) {
    // If the click is NOT inside the overlay
    if ($(e.target).closest('.xmas-popup-overlay').length === 0) {
        $('.xmas-popup-overlay').remove();
    }
});




  // Slide toggle left/right
  $.fn.toggleLeft = function(duration = 400) {
    return this.each(function () {
      const $el = $(this);
      if ($el.is(':visible') && $el.width() > 0) {
        $el.animate({ marginLeft: -$el.outerWidth() }, duration, function () {
          $el.addClass('not-active').hide();
          $(".filter-toggeler .text").text("Show Filter");
        });
      } else {
        $el.show().removeClass('not-active').css({ marginLeft: -$el.outerWidth() });
        $el.animate({ marginLeft: 0 }, duration);
          $(".filter-toggeler .text").text("Hide Filter");
      }
    });
  };
  
  // On .filter-toggeler click
  $(document).on('click', '.filter-toggeler', function() {
    $('#main-collection-filters, #main-search-filters').toggleLeft(300); 
  });
  if ($(window).width() <= 749) {
    setTimeout(function() {
     $(".filter-toggeler .text").text("Show Filter");
    }, 100);
  }
  $('ul.facets-layout-list').each(function () {
    var $ul = $(this);
    var $items = $ul.children('li');

    if ($items.length > 5) {
      // Hide items after the 5th one
      $items.slice(5).hide().addClass('extra-facet');

      // Create and append the toggle button
      var $btn = $('<button class="toggle-facet-list link">Show more</button>');
      $ul.after($btn);

      // Toggle logic
      $btn.on('click', function (e) {
        e.preventDefault();

        var $hiddenItems = $ul.children('.extra-facet');
        var isVisible = $hiddenItems.is(':visible');

        if (isVisible) {
          $hiddenItems.slideUp();
          $btn.text('Show more');
        } else {
          $hiddenItems.slideDown();
          $btn.text('Hide few');
        }
      });
    }
  });


  (function() {
  var $body = $("body");

  var $parent = $body.find(".range-slider");
  if (!$parent.length) return;

  var $rangeS = $parent.find("input[type=range]");
  var $numberS = $parent.find("input[type=text]");

  // Handle change event on range inputs
  $rangeS.on("input change", function() {
    var slide1 = parseFloat($rangeS.eq(0).val());
    var slide2 = parseFloat($rangeS.eq(1).val());

    if (slide1 > slide2) {
      [slide1, slide2] = [slide2, slide1];
    }
// console.log('ready');
    // Update corresponding text inputs
    $numberS.eq(0).val(slide1);
    $numberS.eq(1).val(slide2);

    // Sync the range sliders
    $rangeS.eq(0).val(slide1);
    $rangeS.eq(1).val(slide2);

    // Update background of the sliders
    updateRangeBackground();
  });

  // Handle input event on number text inputs
  $numberS.on("input", function() {
    var number1 = parseFloat($numberS.eq(0).val());
    var number2 = parseFloat($numberS.eq(1).val());

    if (number1 > number2) {
      [number1, number2] = [number2, number1];
    }

    // Update range sliders based on text input values
    $rangeS.eq(0).val(number1);
    $rangeS.eq(1).val(number2);

    // Update background of the sliders
    updateRangeBackground();
  });

  // Function to update the range input backgrounds
  function updateRangeBackground() {
    var $rangeMin = $body.find("#range-min");
    var $rangeMax = $body.find("#range-max");
    var minValue = parseInt($rangeMin.val());
    var maxValue = parseInt($rangeMax.val());
    var min = parseInt($rangeMin.attr("min"));
    var max = parseInt($rangeMin.attr("max"));
    var percentMin = ((minValue - min) / (max - min)) * 100;
    var percentMax = ((maxValue - min) / (max - min)) * 100;

    // Update the background for both sliders
    var backgroundStyle = `linear-gradient(
      to right,
      rgb(129, 129, 129) ${percentMin}%,
      rgb(0, 0, 0) ${percentMin}%,
      rgb(0, 0, 0) ${percentMax}%,
      rgb(129, 129, 129) ${percentMax}%
    )`;

    $rangeMin.css("background", backgroundStyle);
    $rangeMax.css("background", backgroundStyle);
  }

  // Initial background update
  updateRangeBackground();

  // Update background on input change
  $body.find("#range-min").on("input", updateRangeBackground);
  $body.find("#range-max").on("input", updateRangeBackground);

})();